import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { UserTypeSelectionDialogComponent } from './user-type-selection-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule
	],
	declarations: [
		UserTypeSelectionDialogComponent
	],
	exports: [
		UserTypeSelectionDialogComponent
	]
})
export class UserTypeSelectionDialogModule {}
